import {
  PLAYER_MODALS_Z_INDEX_INCREASE,
  PLAYER_MODALS_Z_INDEX_DECREASE,
} from 'containers/Player/actions/optionButtons/constants';

const initialState = 0;

export default (state = initialState, action) => {
  switch (action.type) {
    case PLAYER_MODALS_Z_INDEX_INCREASE:
      return state + 1;
    case PLAYER_MODALS_Z_INDEX_DECREASE:
      return state - 1;
    default:
      return state;
  }
};
